

angular
.module('inkfinder')
.factory('Shop', function Shop(
  $q,
  $http,
  $interval,
  $rootScope,
  ENDPOINT,
  ScheduleUtilFactory,
  moment,
  AlertMessages,
  Session,
  _
) {
  Shop.get = get;
  Shop.getShops = getShops;
  Shop.update = update;
  Shop.add = add;

  /**
   * @name add
   * @description Add a shop
   * @param {object} input The shop to add
   * @return {object} Returns the new shop
   */
  function add(input) {
    return $http.post(ENDPOINT.server + 'shops/api/v1.1/', input)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name get
   * @description Get shop profile
   * @param {number} id The Id of the shop
   * @return {object} Returns a promise object of the shop.
   */
  function get(id) {
    let url = ENDPOINT.server + 'shops/api/v1.1/' + id + '/';
    if (!_.isUndefined(Session.activeState.association)) {
      url += '?association_id=' + Session.activeState.association.id;
    }
    return $http.get(url).then(function(response) {
      Shop.shop = response.data;
      return Shop.shop;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getShops
   * @description Function to get an array of shops based on URL params
   * @param {number} username The username to filter by
   * @return {array} Returns an array of shops
   */
  function getShops(username) {
    let url = ENDPOINT.server + 'shops/api/v1.1/';
    if (!_.isUndefined(username)) {
      url += '?username=' + username;
    }
    return $http.get(url)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @name update
  * @description Function to update the shop profile
  * @param {object} shop The shop to update
  * @return {object} Returns the udpated shop object
  */
  function update(shop) {
    shop.association_id = Session.activeState.association.id;
    return $http.put(ENDPOINT.server + 'shops/api/v1.1/' +
    shop.id + '/', shop)
    .then(function(response) {
      AlertMessages.add({
        msg: 'Your shop profile has been saved.',
        type: 'success'
      });
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Shop;
});



// WEBPACK FOOTER //
// ./components/shop/shop.service.js